import React from 'react';
import { HStack, Text, Box, Button, Spacer } from '@chakra-ui/react';
import { CSVLink } from 'react-csv';
import { AdminUsersArrayStateType } from '../../../pages/AdminUsersMaintenance';
import { CategoryArrayStateType } from '../../../pages/CategoryMaintenance';
import { TrainsArrayStateType } from '../../../pages/TrainsMaintenance';
import { TrainGroupsArrayStateType } from '../../../pages/TrainGroupsMaintenance';
import { PhrasesArrayStateType } from '../../../pages/PhrasesMaintenance';
import { MailingListArrayStateType } from '../../../pages/MailingListMaintenance';
import { SignagesType } from './Table/MaintenanceSignageTable';

export type chooseDataStateType =
  | AdminUsersArrayStateType
  | CategoryArrayStateType
  | TrainsArrayStateType
  | TrainGroupsArrayStateType
  | PhrasesArrayStateType
  | SignagesType
  | MailingListArrayStateType;

interface props {
  CsvData: any | undefined;
  DataLength: number | undefined;
  Headers: {
    label: string;
    key: string;
  }[];
  CsvFileName: string;
  GetPageCount: () => number;
  pageMax: number;
  pageNow: number;
  setPageNow: React.Dispatch<React.SetStateAction<number>>;
}

export const MaintenanceFooter: React.FC<props> = (props) => {
  const {
    CsvData,
    DataLength,
    Headers,
    CsvFileName,
    GetPageCount,
    pageMax,
    pageNow,
    setPageNow
  } = props;

  return (
    <Box mt={3} float='right' gridRow='3/3' gridColumn='1/2'>
      <HStack>
        <Text>ダウンロード</Text>
        <CSVLink
          style={{
            marginLeft: 10,
            color: 'blue'
          }}
          filename={CsvFileName}
          data={CsvData}
          headers={Headers}
        >
          CSV
        </CSVLink>

        <Spacer />
        <HStack spacing={5}>
          <HStack>
            {pageNow !== 1 && GetPageCount() > pageMax && (
              <>
                <Button
                  bgColor='silver'
                  h={5}
                  fontSize={16}
                  _hover={{ bg: 'transparent' }}
                  onClick={() => setPageNow(1)}
                >
                  {1}
                </Button>
                <Text>..</Text>
              </>
            )}
            {[...new Array(pageMax)].map((_, i) => {
              if (i > GetPageCount() - 1) {
                return;
              }
              if (GetPageCount() < pageMax) {
                return (
                  <Button
                    key={`${'page_' + i}`}
                    bgColor='silver'
                    h={5}
                    fontSize={16}
                    _hover={{ bg: 'transparent' }}
                    onClick={() => setPageNow(i + 1)}
                    disabled={i + 1 === pageNow ? true : false}
                  >
                    {i + 1}
                  </Button>
                );
              }
              if (pageNow < GetPageCount() - (pageMax - 1)) {
                return (
                  <Button
                    key={`${'page_' + i}`}
                    bgColor='silver'
                    h={5}
                    fontSize={16}
                    _hover={{ bg: 'transparent' }}
                    onClick={() => setPageNow(i + pageNow)}
                    disabled={pageNow + i === pageNow ? true : false}
                  >
                    {pageNow + i}
                  </Button>
                );
              } else {
                return (
                  <Button
                    key={`${'page_' + i}`}
                    bgColor='silver'
                    h={5}
                    fontSize={16}
                    _hover={{ bg: 'transparent' }}
                    onClick={() =>
                      setPageNow(GetPageCount() - (pageMax - 1) + i)
                    }
                    disabled={
                      GetPageCount() - (pageMax - 1) + i === pageNow
                        ? true
                        : false
                    }
                  >
                    {GetPageCount() - (pageMax - 1) + i}
                  </Button>
                );
              }
            })}
            {GetPageCount() - (pageNow + pageMax - 1) > 0 && (
              <>
                <Text>..</Text>
                <Button
                  bgColor='silver'
                  h={5}
                  fontSize={16}
                  _hover={{ bg: 'transparent' }}
                  onClick={() => setPageNow(GetPageCount())}
                >
                  {GetPageCount()}
                </Button>
              </>
            )}
          </HStack>
          <HStack>
            <Button
              bgColor='silver'
              h={5}
              fontSize={16}
              _hover={{ bg: 'transparent' }}
              disabled={
                pageNow <= 1
                  ? true
                  : false ||
                    (DataLength === undefined || DataLength === 0
                      ? true
                      : false)
              }
              onClick={() => setPageNow(pageNow - 1)}
            >
              {'<'}
            </Button>
            <Button
              bgColor='silver'
              h={5}
              fontSize={16}
              _hover={{ bg: 'transparent' }}
              disabled={
                pageNow === GetPageCount()
                  ? true
                  : false ||
                    (DataLength === undefined || DataLength === 0
                      ? true
                      : false)
              }
              onClick={() => setPageNow(pageNow + 1)}
            >
              {'>'}
            </Button>
          </HStack>
        </HStack>
      </HStack>
    </Box>
  );
};
